<template>
  <div class="h-100">
    <b-card-text class="msm-title cx-simple-title lines-1 line-clamp-2">
      {{ $t("Webportal.CX.Dashboard.ActionManagement") }}
    </b-card-text>

    <b-row class="mb-3">
      <b-col sm="12" xl="6">
        <b-progress :max="100" height="2.25rem" show-progress class="mb-1">
          <b-progress-bar
            :style="{ 'background-color': getColor(resolvedValue) }"
            :value="resolvedValue"
            style="font-size: 0.75rem; text-shadow: 2px 2px 5px #000"
          >
            <span
              class="justify-content-center d-flex position-absolute"
              style="width: 85%"
            >
              {{ resolvedValue }}%
            </span>
          </b-progress-bar>
        </b-progress>
      </b-col>
      <b-col sm="12" xl="6">
        <b-button block @click="ShowActionManagementCenter = !ShowActionManagementCenter" variant="primary" class="mb-1">
          {{ $t("Webportal.Actions.StartActionsButtonLabel") }}
        </b-button>
      </b-col>
    </b-row>

    <b-card-text>
      <b-card no-body class="mb-1" style="width:100%">
        <b-card-body class="py-0">
          <b-row class="text-center my-1">
            <b-col cols="8" style="border-right: 1px solid lightgrey">
              {{ $t('Webportal.CX.Dashboard.ActionManagementCenter.TakingAction') }}
            </b-col>
            <b-col cols="4">
              {{ unresolvedValue }}%
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-card no-body class="mb-1" style="width:100%">
        <b-card-body class="py-0">
          <b-row class="text-center my-1">
            <b-col cols="8" style="border-right: 1px solid lightgrey">
              {{ $t("Webportal.CX.Dashboard.ActionManagementCenter.ResolvedActionsToTake") }}
            </b-col>

            <b-col cols="4">
              {{ resolved }} / {{ maxResolvable }}
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-card-text>

    <!-- Popup -->
    <ActionManagementCenter
      v-show="ShowActionManagementCenter"
      class="popup action-management-center-popup"
      :explorationData="actionManagementCenter_ExpData"
      :explorationAugmentionData="actionManagementCenter_ExpAugData"
      :clientLocationId="dashboardData.ClientLocationId"
      :resolvedApiIds="dashboardData.Exploration.ResolvedApis"
      :resolvedExtSurveyIds="getResolvedApisFromSurveys()"
      @close="ShowActionManagementCenter = false"
      @resolved="resolvedFirstAidKit"
    />
  </div>
</template>

<script>
import ActionManagementCenter from "./ActionManagementCenter";
import EventBus from "@/services/EventBus";
import CxActionManagementMixin from "@/mixins/CxActionManagementMixin";

export default {
  name: "ActionManagementCard",

  components: { ActionManagementCenter },

  mixins: [ CxActionManagementMixin ],

  data() {
    return {
      ShowActionManagementCenter: false,
      RefreshCounter: 0 /* Hack / Workaround */
    };
  },

  watch: {
    dashboardData: function() {
      EventBus.$emit("FirstAidPercentage", {solved: this.resolved, all: this.maxResolvable});
    }
  },

  created: function() {
    EventBus.$on("queryFirstAidPercentage", () => {
      EventBus.$emit("FirstAidPercentage", {solved: this.resolved, all: this.maxResolvable});
    });
  }
};
</script>

<style scoped>
.card-h {
  min-height: 500px;
}
.cx-card-tgt .card {
  padding: 0.75rem !important;
}
.cx-card-tgt .card .card-body {
  padding: 0.5rem !important;
}
.lines-2 {
  min-height: 4.5rem;
  /* min-height: 5.25rem; */
}
.line-clamp-2 {
  text-overflow: ellipsis;
  overflow: hidden;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.action-management-center-popup {
  position: fixed !important;
  width: 1300px;
  /* min-height: 600px;
  max-height: 650px; */
  top: 100px;
  left: 250px;
  border: none;
  box-shadow: 3px 3px 13px -3px var(--border-color-secondary);
}

.row {
  flex-direction: row;
    align-items: center;
}
</style>
